import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';
import { ItemCategoryService, ItemsCategoryInputDto, ItemsCategoryUpdateDto, StoreResponseDto } from 'src/generated_client';

@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.css']
})
export class AddCategoryComponent implements OnInit {
  id: any;
  isEdit: boolean = false;
  title: string = "";

  options = [
    { value: true, viewValue: 'Activa' },
    { value: false, viewValue: 'Desactivada' },
  ];

  addCategoryForm: FormGroup = this.fb.group({
    cdItemCategory: [],
    name: ['', Validators.compose([Validators.pattern('[A-Z][a-z ]*'), Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    status: ['', Validators.required],
    order: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])]
  })

  categoryInput: ItemsCategoryInputDto = {} as ItemsCategoryInputDto;
  categoryUpdate: ItemsCategoryUpdateDto = {} as ItemsCategoryUpdateDto;
  storeResponse: StoreResponseDto = {} as StoreResponseDto;

  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private categoryService: ItemCategoryService,
    private authService: AuthService,
    private router: Router,
    private snackBar: SnackBarService,
    private dialog: MatDialog,
    private categService: ItemCategoryService
  ) { }

  ngOnInit(): void {
    this.storeResponse = this.authService.currentUserStore();

    this.id = this.activatedRoute.snapshot.paramMap.get("id")

    if (this.id != null) {

      this.isEdit = true;

      this.categoryService.apiItemCategoryGetOneGet(this.id).subscribe(x => {

        this.addCategoryForm.controls['cdItemCategory'].setValue(x.cdItemsCategory);
        this.addCategoryForm.controls['name'].setValue(x.dsTitle);
        this.addCategoryForm.controls['status'].setValue(x.isEnabled);
        this.addCategoryForm.controls['order'].setValue(x.nmOrder);
      })
    }

    this.changeTitle();
  }

  changeTitle() {
    if (this.isEdit) {
      this.title = "EDITAR CATEGORÍA";
    } else {
      this.title = "AGREGAR NUEVA CATEGORÍA";
    }
  }

  saveChanges(form: any) {
    if (this.isEdit) {

      this.categoryUpdate = {
        cdItemsCategory: form.cdItemCategory,
        cdStore: Number(this.storeResponse.cdStore),
        dsTitle: form.name,
        dsDescription: undefined,
        nmOrder: Number(form.order),
        isEnabled: form.status
      }

      this.categoryService.apiItemCategoryEditPut(this.categoryUpdate).subscribe(response => {

        if (!response.isEnabled) {

          const dialogRef = this.openDialog();

          dialogRef.afterClosed().subscribe((confirmed: boolean) => {

            if (confirmed) {

              this.categService.apiItemCategoryChangeStatePut(this.id).subscribe(() => {

                this.router.navigate(['categories-management']);
                this.snackBar.openSnackBar('Los cambios fueron guardados correctamente', 'Aceptar')
              },
                err => {
                  this.snackBar.openSnackBar(err.error.error, 'Aceptar');
                }
              );
            }
            else {
              this.router.navigate(['edit-category', this.id])
            }
          })
        }
        else {
          this.router.navigate(['categories-management']);
          this.snackBar.openSnackBar('Los cambios se guardaron correctamente', 'Aceptar')
        }
      },
        err => {
          this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar')
        }
      );

    } else {

      this.categoryInput = {
        cdStore: Number(this.storeResponse.cdStore),
        dsTitle: form.name,
        dsDescription: undefined,
        nmOrder: Number(form.order),
        isEnabled: form.status
      }

      this.categoryService.apiItemCategoryPostPost(this.categoryInput).subscribe(response => {

        this.router.navigate(['categories-management']);
        this.snackBar.openSnackBar('Los cambios se guardaron correctamente', 'Aceptar')
      },
        err => {
          this.snackBar.openSnackBar(err.error.error, 'Aceptar')
        }
      );
    }
  }

  private openDialog() {
    return this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: 'Se desactivarán los productos dentro de la categoría, Desea continuar?'
      }
    });
  }
}
